<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggle(event) {
      if (this.multiple) {
        this.item.active = !this.item.active
      } else {
        this.$parent.$children.forEach((item, index) => {
          if (
            item.$el.id === event.currentTarget.parentElement.parentElement.id
          ) {
            item.item.active = !item.item.active
          } else {
            item.item.active = false
          }
        })

        this.$forceUpdate()
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + 'px'
    },

    endTransition(el) {
      el.style.height = ''
    },
  },
}
</script>
<template>
  <div
    :id="groupId + '-' + item._id"
    class="accordion-item"
    :class="{ 'is-active': item.active }"
  >
    <dt class="accordion-item-title">
      <button class="accordion-item-trigger" @click="toggle">
        <h5 class="accordion-item-title-text">{{ item.title }}</h5>
        <span class="accordion-item-trigger-icon"></span>
      </button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-if="item.active" class="accordion-item-details">
        <div class="accordion-item-details-inner">
          <b-list-group v-for="(content, index) of item.content" :key="index">{{
            content.title
          }}</b-list-group>
        </div>
      </dd>
    </transition>
  </div>
</template>
<style lang="scss" scoped>
$browser-context: 16;
$blue: #1779ba;
$gray: #cacaca;
$red: #cc4b37;
$white: #fff;

@function em($pixels, $context: $browser-context) {
  @return #{$pixels / $context}em;
}

#app {
  padding: em(12);
  margin: em(60) auto;
}

.btn-action-delete {
  color: $red;
  cursor: pointer;
}
.accordion-item-details {
  overflow: hidden;
  background-color: whitesmoke;
}
.accordion {
  padding: 0;

  div:not(:last-child) {
    border-bottom: 1px solid rgba(10, 10, 10, 0.1);
  }

  div:last-child .accordion-item-details {
    border-radius: 5px;
  }

  dd {
    margin-left: 0;
  }
}

.accordion-item-trigger,
.accordion-item-details-inner {
  padding: 0.75rem 1.25rem;
}

.accordion-item-title {
  position: relative;

  h4 {
    padding-right: 1.25rem;
    margin-bottom: 0;
    font-size: 1.25rem;
  }
}
.false {
  display: none;
}
.true {
  display: block;
}
.accordion-item-trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
}

.accordion-item-trigger-icon {
  $size: 8px;

  position: absolute;
  top: 0;
  right: 1.25rem;
  bottom: 0;
  display: block;
  width: $size;
  height: $size;
  margin: auto;
  border-right: 2px solid #363636;
  border-bottom: 2px solid #363636;
  transition: transform 0.2s ease;
  transform: translateY(-$size / 4) rotate(45deg);

  .is-active & {
    transform: translateY($size / 4) rotate(225deg);
  }
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
.list-group {
  padding: 8px;
}
</style>
